import React from 'react'
import Layout from '../../Components/Layout'
import ResetPasswordSetting from '../../Components/ProfileSetting/ResetPasswordSetting'

/**
 * The function returns a layout with the reset password component.
 * @returns a JSX element. It is returning a Layout component with a paragraph element and a
 * ResetPasswordSetting component inside it.
 */
function ResetPasswordPage() {
    return (
        <Layout>
            <p className="mt-[3.5rem]">  </p>
            <ResetPasswordSetting />
        </Layout>
    )
}

export default ResetPasswordPage;
